import {module} from 'modujs';
import Utils from "../utils/utils";
import {gsap} from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);

    /**
     * Set Settings
     */
    this.state = {
      countries: null,
      marches: null,
      expertises: null,
      status: null
    }
    this.navStyle = {
      active: {color: '#E8B1A2', opacity: 1},
      disabled: {color: '#1C2544', opacity: 0.3}
    }

    this.cards = this.el.querySelectorAll('.filtersCompanies-card')
    this.filters = this.el.querySelectorAll('input[type="checkbox"]')
    this.options = this.el.querySelectorAll('select option')
    this.cleanBtn = this.el.querySelector('button.js-clean')
    this.noItem = this.el.querySelector('.filtersCompanies-no-item')
    this.selectExpertises = this.el.querySelector('#expertises')
    this.optionsExpertises = this.el.querySelectorAll('#expertises option')
    this.optionsMarches = this.el.querySelectorAll('#marches option')
    this.toggleFilters = document.querySelectorAll('.js-scrollinglist-toggle')

  }

  init() {
    let self = this;

    if(self.cleanBtn) {
      self.cleanBtn.addEventListener('click', function () {
        self.cleanAll();
      })
    }

    self.filters.forEach(item => {
      item.addEventListener('change', function (e) {
        e.preventDefault()
        self.toggleColor(item)
        self.manager(item)
      })
    })

    self.toggleFilters.forEach(item => {
      item.addEventListener('click', self.handleClickOnToggle)

      if(window.matchMedia('(max-width: 768px)').matches) {
        item.parentElement.classList.toggle('active')
      }
    })
  }



  /**
   * State Filter Manager
   */

  manager(item) {
    const countries_checked = document.querySelectorAll('input[type="checkbox"][data-index="Pays"]:checked')

    if(countries_checked.length) {
      this.state.countries = []

      countries_checked.forEach((el) => {
        this.state.countries.push(el.value)
      })
    } else {
      this.state.countries = null
    }

    const marches_checked = document.querySelectorAll('input[type="checkbox"][data-index="Marchés"]:checked')

    if(marches_checked.length) {
      this.state.marches = []

      marches_checked.forEach((el) => {
        this.state.marches.push(el.value)
      })
    } else {
      this.state.marches = null
    }

    const expertises_checked = document.querySelectorAll('input[type="checkbox"][data-index="Expertises"]:checked')

    if(expertises_checked.length) {
      this.state.expertises = []

      expertises_checked.forEach((el) => {
        this.state.expertises.push(el.value)
      })
    } else {
      this.state.expertises = null
    }

    const status_checked = document.querySelectorAll('input[type="checkbox"][data-index="Statuts"]:checked')

    if(status_checked.length) {
      this.state.status = []

      status_checked.forEach((el) => {
        this.state.status.push(el.value)
      })
    } else {
      this.state.status = null
    }

    if(expertises_checked.length || status_checked.length || status_checked.length || countries_checked.length) {
      document.querySelector('.js-clean').classList.add('active')
    } else {
      document.querySelector('.js-clean').classList.remove('active')
    }

    this.filter(this.state)
  }

  /**
   * Filter le select des marché en fonction de celui des expertises
   * Petit addon client de dernière minute qui fait plaisir
   */
  filterMarketFromExpertise(){
    console.debug('filterMarketFromExpertise', this.state.expertises);
    if(this.state.expertises){

      // on récupère le marché en fonction du select expertise selectionné
      let selectedExpertiseMarket = this.optionsExpertises[this.selectExpertises.selectedIndex].dataset.marche;
      let marches = selectedExpertiseMarket.replace(/\s/g, '').split(',')

      console.debug(marches);
      //
      this.optionsMarches.forEach((elt, index) => {
        if( !marches.includes(elt.value)){
          elt.setAttribute('hidden', 'hidden');
        } else {
          elt.removeAttribute('hidden');
        }
      })
    }
  }

  /**
   * Filter le select des expertise en fonction de celui des marché
   * Petit addon client de dernière minute qui fait plaisir
   */
  filterExpertisesFromMarket(){
    console.debug('filterExpertisesFromMarket', this.state.marches);
    if(this.state.marches){
      this.optionsExpertises.forEach((elt, index) => {
        if(elt.dataset.marche){
          let marches = elt.dataset.marche.replace(/\s/g, '').split(',')
          if( !marches.includes(this.state.marches)){
            elt.setAttribute('hidden', 'hidden');
          } else {
            elt.removeAttribute('hidden');
          }
        }

      })
    }

  }

  /**
   *  Filter Front Card
   */
  filter(state) {

    const ArrayFilter = [];
    const ArrayNoFilter = [];

    this.cards.forEach(item => {
      let countriesItem = item.dataset.countries.replace(/\s/g, '').split(',')
      let marchesItem = item.dataset.marches.replace(/\s/g, '').split(',')
      let expertiseItem = item.dataset.expertises.replace(/\s/g, '').split(',')
      let statusItem = item.dataset.statuts.replace(/\s/g, '').split(',')

        if(state.countries && !ArrayFilter.includes(item)) {
          let country_match = false
          
          countriesItem.forEach((el) => {
            if (state.countries.includes(el) && !country_match) {
              country_match = true
            }
          })

          if(!country_match) {
            ArrayFilter.push(item);
          }
        }

        if(state.marches && !ArrayFilter.includes(item)) {
          let marches_match = false
 
          marchesItem.forEach((el) => {
            if (state.marches.includes(el) && !marches_match) {
              marches_match = true
            }
          })
 
          if(!marches_match) {
            ArrayFilter.push(item);
          }
        }
  
        if(state.expertises && !ArrayFilter.includes(item)) {
          let expertises_match = false 
          
          expertiseItem.forEach((el) => {
            if (state.expertises.includes(el) && !expertises_match) {
              expertises_match = true
            }
          })

          if(!expertises_match) {
            ArrayFilter.push(item);
          }
        }

        if(state.status && !ArrayFilter.includes(item)) {
          let status_match = false
          
          statusItem.forEach((el) => {
            if (state.status.includes(el) && !status_match) {
              status_match = true
            }
          })

          if(!status_match) {
            ArrayFilter.push(item);
          }
        }
    })
    this.cards.forEach(item => {
      if (!ArrayFilter.includes(item)) {
        ArrayNoFilter.push(item)
      } 
    })

    let tl = new gsap.timeline()
    tl.to(this.cards,{opacity:0,display:'none',duration:0.3,ease:'power2.out'})
    tl.to(ArrayNoFilter,{opacity:1,display:'flex',duration:0.4,ease:'power2.out'})

    console.debug('Résultats trouvés : ' + (this.cards.length - ArrayFilter.length));

    // if no item
    if (ArrayFilter.length === this.cards.length){
      this.noItem.style.display = 'inline'
    } else this.noItem.style.display = ''

    setTimeout(() => {
      document.querySelector('.filtersCompanies').scrollIntoView({
        behavior: 'smooth'
      });
    }, 300)

  }

  /**
   *  Set color on nav
   */
  toggleColor(item) {
    if (item.value) {
      item.closest('div').classList.add('active');
      // item.style.color = this.navStyle.active.color
      // item.style.opacity = this.navStyle.active.opacity
    } else {
      item.closest('div').classList.remove('active');
      // item.style.color = this.navStyle.disabled.color
      // item.style.opacity = this.navStyle.disabled.opacity
    }
  }

  /**
   *  Clean Filters
   */
  cleanAll() {
    let self = this;
    this.filters.forEach(item => {
      item.checked = false
    })
    let tl = new gsap.timeline()
    tl.to(this.cards,{opacity:0,display:'none',duration:0.3,ease:'power2.out'})
    tl.to(this.cards,{opacity:1,display:'flex',duration:0.4,ease:'power2.out'})

    this.options.forEach(item => {
      item.removeAttribute('hidden');
    })

    this.state = {
      countries: null,
      marches: null,
      expertises: null,
      status: null
    }
    this.noItem.style.display = ''

    setTimeout(() => {
      document.querySelector('.filtersCompanies').scrollIntoView({
        behavior: 'smooth'
      });
    }, 300)
  }  

  /**
   *  Destroy
   */
  destroy() {
    console.log('Destroy Filter ✅')
    this.filters.forEach(el => {
      el.removeEventListener('change', this)
    })
    this.cleanBtn.removeEventListener('click', this)
  }

  /**
   *  Clean Filters
   */

  

	handleClickOnToggle(e) {
		e.currentTarget.parentElement.classList.toggle('active')
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/filtersCompanies.js